<template>
    <div class="dynamic-wrap">
        <div class="teaching-dynamics-content">
            <div class="data-list" :id="dynamicData.length>8?'dynamic-ul':''">
                <div class="data-box">
                    <div style="width: 50%;" v-for="(sitem, sindex) in dynamicData" :key="sindex">
                        <div class="data-box-item" v-on:click="lookTeaDynamic(sitem)"
                            :style="sindex % 2 == 0 ? `right: ${Math.floor(Math.random() * 3).toFixed(1)}vw` : `left: ${Math.floor(Math.random() * 3).toFixed(1)}vw`">
                            <div class="title">
                                <!-- {{ getSourceByType(sitem.type) }} {{ sitem.operation_time }} -->
                                  {{ sitem.teaName }}老师  {{sitem.subjectName}}
                            </div>
                            <div class="info" :title="`上传课件数${sitem.uploadRsNum},上传微课数${sitem.uploadCwNum},分享课件数${sitem.shareRsNum},分享微课数${sitem.shareCwNum}`">
                                上传课件数{{sitem.uploadRsNum}},上传微课数{{sitem.uploadCwNum}},分享课件数{{sitem.shareRsNum}},分享微课数{{sitem.shareCwNum}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <img class="center-background" :src="require('@/assets/images/sydataboard/center-bg.png')" alt="">
        <img class="left-background" :src="require('@/assets/images/sydataboard/left-bg.png')" alt="">
        <img class="right-background" :src="require('@/assets/images/sydataboard/right-bg.png')" alt="">

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { findHomeworkInfo, findResourceInfo, findInterInfo, findUserInfo } from "../../../service/api.js";

export default {
    name: "tea-dynamic",
    props: {
        dynamicData: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            dynamicList: [],
            top: [],
            left: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
            color: ['#FFF', '#0EFCFF', '#4889FF', '#FAE17C'],
            scrollInterval: {},//动态滚动区间,
            scrollIngDynamicList: [],
            timer: null,
            hwUserSubjectId: null,
            channel: process.env.VUE_APP_CHANNEL,
        }
    },
    computed: {
        ...mapGetters([
            'homeWorkReportPath'
        ]),
        renderDynamicList: {
            get: function () {
                if (this.dynamicData.length > 0) {
                    return this.initDynamicData(this.dynamicData);
                }
            }
        }
    },
    methods: {
        /**
* @name 获取来源
*/
        getSourceByType(type) {
            let name = ''
            switch (type) {
                case 1:
                    name = '作业';
                    break;
                case 2:
                    name = '资源';
                    break;
                case 3:
                    name = '评价';
                    break;
                case 4:
                    name = '互动';
                    break;
                case 5:
                    name = '题库';
                    break;
                case 6:
                    name = '活动评审';
                    break;
                case 7:
                    name = '名师工作室';
                    break;
                case 8:
                    name = '集体备课';
                    break;
                case 9:
                    name = '听评课';
                    break;
                case 10:
                    name = '教师布置作业';
                    break;
                case 11:
                    name = '特色活动';
                    break;
                case 12:
                    name = '在线课程';
                    break;
            }
            return name
        },
        /**
         * 初始化实时动态top,left,color
         */
        initDynamicData(list) {
            let _this = this;
            let minTop = 45;
            let newList = [];
            //判断动态是否小于9条 小于9条则复制3份 实现从底部滚动的效果
            if (list.length < 9) {
                for (let i = 0; i < 3 * list.length; i++) {
                    let dynamicObj = {};
                    dynamicObj.id = list[i % list.length].id;
                    dynamicObj.operation = list[i % list.length].operation;
                    dynamicObj.operation_time = list[i % list.length].operation_time;
                    dynamicObj.realname = list[i % list.length].realname;
                    dynamicObj.type = list[i % list.length].type;
                    dynamicObj.tempIndex = i;
                    newList.push(dynamicObj);
                }
            } else {
                newList = list;
            }

            for (let i = 1; i <= newList.length; i++) {
                let curTop = i * minTop;
                _this.top.push(curTop);

            }
            for (let j = 0; j < newList.length; j++) {
                var leftIndex = parseInt(_this.left.length * Math.random());
                newList[j]['left'] = _this.left[leftIndex];
                var colorIndex = parseInt(4 * Math.random());
                newList[j]['top'] = _this.top[j];
                newList[j]['color'] = _this.color[colorIndex];
            }

            _this.scrollInterval.minTop = minTop;
            _this.scrollInterval.maxTop = minTop * newList.length - 30;

            this.timer = setInterval(_this.dynamicScroll, 20);
            return newList;

        },
        /**
         * 鼠标悬停停止滚动
         */
        hoverEvent() {
            clearInterval(this.timer);
        },
        /**
         * 鼠标离开继续滚动
         */
        mouseleaveEvent() {
            this.timer = setInterval(this.dynamicScroll, 20);
        },
        /**
         * 动态滚动效果
         */
        dynamicScroll() {
            let _this = this;
            let arr = this.$refs.dynamicUl.children;
            for (var i = 0; i < arr.length; i++) {
                if (_this.scrollIngDynamicList.length != arr.length) {
                    _this.scrollIngDynamicList[i] = arr[i].offsetTop;

                }
                arr[i].style.top = _this.scrollIngDynamicList[i] + "px";
                _this.scrollIngDynamicList[i]--;
                if (_this.scrollIngDynamicList[i] < -30) {
                    _this.scrollIngDynamicList[i] = _this.scrollInterval.maxTop;
                }
            }
        }
    },
    destroyed() {
        //组件销毁时手动销毁事件
        clearInterval(this.timer);
    }
}
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";

.center-background {
    height: calc(100% - 70px);
    width: auto;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
}

.left-background {
    width: auto;
    height: 100%;
    position: absolute;
    top: 0;
    left: -5px;
}

.right-background {
    width: auto;
    height: 100%;
    position: absolute;
    top: 0;
    right: -5px;
}

.teaching-dynamics-content {
    width: 100%;
    height: calc(100% - 20px);
    position: relative;
    overflow: hidden;
    margin: 0 auto;

    .data-list {
        width: 100%;
        // height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        // justify-content: center;
        position: relative;
        z-index: 2;
    }

    #dynamic-ul {
        &.data-box {
            cursor: pointer;
        }

        // height: 100%;
        animation: infinitevertical 30s linear infinite;

        &:hover {
            animation-play-state: paused;
        }

    }

    /* 无限滚动垂直 */
    @keyframes infinitevertical {
        0% {
            transform: translateY(0%);
        }

        100% {
            transform: translateY(-25%);
        }
    }

    .data-box {
        width: 100%;
        display: flex;
        align-items: center;
        display: flex;
        // flex-direction: column;
        justify-content: space-between;
        flex-wrap: wrap;
        position: relative;
        z-index: 2;

        // margin-bottom: 65px;

        // margin: 20px 0;
        .data-box-item {
            display: inline-block;
            //width: 250px;
            width: 100%;
            margin-bottom: 35px;
            // padding: 0 10px;
            padding: 0 15px;
            color: #FFFFFF;
            text-align: left;
            position: relative;
            cursor: pointer;
            background: linear-gradient(-2deg, #2465CF 0%, transparent 60%);

            .title {
                font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
                margin-bottom: 10px;
            }

            .info {
                font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            &:hover {
                background: linear-gradient(0deg, #D88815 0%, #0C1947 100%);
            }
        }
    }
}
</style>

